module.exports = __webpack_public_path__ + "static/media/co.pictogram.15a03d56.svg";